// extracted by mini-css-extract-plugin
module.exports = {"container":"icon_container__1zAw6"};